// src/utils/concurrencia.js
// =========================================================================
// 🔀 EDICIÓN SIMULTÁNEA: al guardar una ficha se envía la versión que se cargó
// (cabecera If-Match). Si otra persona guardó entretanto, el servidor responde
// 409 con un mensaje claro y no se pisa su trabajo (backend/src/utils/concurrencia.js).
// =========================================================================

/** Opciones de axios con la versión de la entidad cargada, si la tiene. */
export function conVersion(entidad, opciones = {}) {
    const version = entidad?.version;
    if (!Number.isInteger(version)) return opciones;
    return { ...opciones, headers: { ...(opciones.headers || {}), 'If-Match': String(version) } };
}
